module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARwAAAGIBAMAAABhLUKGAAAAGFBMVEX////b9f/i9//u+//o+f/6/v/2/f/z/P9N0nWqAAABN0lEQVR42u3SsY3CQBRF0Z9QAO7AFh0YiRwogMTuADewErS/DokmWGnxk3XOjPOrNy4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD+6hClHlHi1om6NT2mQ86tw/YNH7emKHLkyFntPmeekk5tXvB5plqeQWepOUo9o9S8JKllTlJLFDlydpPzSpK2zitKvaPIkSPnP9T7kiRtnTFKXaLUT5S0xxqjyJEjZyWnZfc5tyjWsc5e1hlvSeo8Jklb535OUrd7krpHkSNHzmr3OdckcesMUbIe61qnKGmPdYpiHetYZ7X/dYYkaesMUeS0VBfFOtaxzso6X1X90HU5Xw190FnX2bzh48T9O8co1UdJW+fYd0E3bp0ocuTIWclpkdMip0VOi5wWOS1yvuoXKmhKwuJYcI0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/phone-down-bg.png
// module id = 381
// module chunks = 0